/**
 * API Endpoints
 * 
 * Chức năng: Định nghĩa tất cả các API endpoints của backend
 * Dùng để: 
 * - Tập trung quản lý tất cả endpoints ở một nơi
 * - Tránh hardcode URL trong code
 * - Dễ dàng thay đổi và maintain
 * - Đảm bảo mobile và desktop dùng cùng endpoints
 */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHANGE_PASSWORD: '/auth/change-password',
    VERIFY_OTP: '/auth/verify-otp',
  },
  USERS: {
    LIST: '/users',
    DETAIL: (id: string) => `/users/${id}`,
    BY_EMPLOYEE_CODE: (employeeCode: string) =>
      `/users/employee-code/${encodeURIComponent(employeeCode)}`,
    CREATE: '/users',
    UPDATE: (id: string) => `/users/${id}`,
    DELETE: (id: string) => `/users/${id}`,
    PROFILE: '/users/profile',
    UPLOAD_AVATAR: (id: string) => `/users/${id}/avatar`,
    EDUCATION_HISTORY: (id: string) => `/users/${id}/education-history`,
    WORK_EXPERIENCE: (id: string) => `/users/${id}/work-experience`,
    FAMILY_MEMBERS: (id: string) => `/users/${id}/family-members`,
    CERTIFICATES: (id: string) => `/users/${id}/certificates`,
    PARTY_HISTORY: (id: string) => `/users/${id}/party-history`,
    ID_CARDS: (id: string) => `/users/${id}/id-cards`,
    PERSONAL_FILES: (id: string) => `/users/${id}/personal-files`,
    HOROSCOPE: (id: string) => `/users/${id}/horoscope`,
  },
  UPLOAD: {
    AVATAR: '/upload/avatar',
    TUVI: '/upload/tuvi',
  },
  DEPARTMENTS: {
    LIST: '/departments',
    DETAIL: (id: string) => `/departments/${id}`,
    CREATE: '/departments',
    UPDATE: (id: string) => `/departments/${id}`,
    DELETE: (id: string) => `/departments/${id}`,
    WITH_EMPLOYEES: '/departments/with-employees',
  },
  ATTENDANCE: {
    CHECK_IN: '/attendance/check-in',
    CHECK_OUT: '/attendance/check-out',
    TODAY: '/attendance/today',
    HISTORY: '/attendance/history',
    LIST: '/attendance',
    DETAIL: (id: string) => `/attendance/${id}`,
    MY_ATTENDANCE: '/attendance/my',
    STATS: '/attendance/stats',
    REPORT: '/attendance/report',
  },
  ACTIVITY_LOGS: {
    LIST: '/activity-logs',
    MY_LOGS: '/activity-logs/my',
  },
  NOTIFICATIONS: {
    LIST: '/notifications',
    MARK_READ: (id: string) => `/notifications/${id}/read`,
    MARK_ALL_READ: '/notifications/read-all',
    DELETE: (id: string) => `/notifications/${id}`,
    DELETE_MANY: '/notifications/delete-many',
  },
  WORK_SHIFTS: {
    LIST: '/work-shifts',
    DETAIL: (id: string | number) => `/work-shifts/${id}`,
    CREATE: '/work-shifts',
    UPDATE: (id: string | number) => `/work-shifts/${id}`,
    DELETE: (id: string | number) => `/work-shifts/${id}`,
    ACTIVATE: (id: string | number) => `/work-shifts/${id}/activate`,
  },
  GPS_LOCATIONS: {
    LIST: '/gps-locations',
    MY_ALLOWED: '/gps-locations/my-allowed',
    DETAIL: (id: string | number) => `/gps-locations/${id}`,
    CREATE: '/gps-locations',
    UPDATE: (id: string | number) => `/gps-locations/${id}`,
    DELETE: (id: string | number) => `/gps-locations/${id}`,
    ACTIVATE: (id: string | number) => `/gps-locations/${id}/activate`,
  },
  MEAL_ALLOWANCE_CONFIG: {
    GET: '/meal-allowance-config',
    HISTORY: '/meal-allowance-config/history',
    UPDATE: '/meal-allowance-config',
  },
  COMPANIES: {
    GET: '/companies',
    CREATE: '/companies',
    UPDATE: '/companies',
    DELETE: '/companies',
  },
  USER_UPDATE_REQUESTS: {
    LIST: '/user-update-requests',
    DETAIL: (id: string) => `/user-update-requests/${id}`,
    APPROVE: (id: string) => `/user-update-requests/${id}/approve`,
    REJECT: (id: string) => `/user-update-requests/${id}/reject`,
  },
} as const;
